// @ts-nocheck
import dom from "../../dom2.js";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const dontTreeShakeDom = dom;
import classnames from "classnames";

/**
 * Sets up a shadow host element. Prevents outside styles from affecting
 * elements inside, and attaches a stylesheet.
 *
 * @param {Object}    props
 * @param {string}    props.classId
 * @param {function}  props.onStylesLoaded callback so that child elements can be added
 * @param {string}    props.stylesheet stylesheet path
 * @return {HTMLElement}
 */
const ShadowHost = props => {
	const {classId, onStylesLoaded, stylesheet, ...rest} = props;

	// Set up shadow host
	const host = <div
		className={classnames("pn-shadow-host", classId)}
		{...rest}
	></div>;

	host.style.setProperty("all", "initial", "important");
	const shadowRoot = host.attachShadow({mode: "open"});

	// Attach styles
	if (stylesheet) {
		const href = window?.LEO?.integrationCssUrls[stylesheet] ?? `/assets/css/temp-browser-ext/${stylesheet}`; // TODO

		const styles = <link
			href={href}
			rel="stylesheet"
			type="text/css"
		></link>;

		styles.addEventListener("load", () => onStylesLoaded(shadowRoot));

		shadowRoot.append(styles);
	} else
		onStylesLoaded(shadowRoot);

	return host;
};

export default ShadowHost;

/**
 * Top level container to be used as a direct child to a shadow root.
 *
 * @param {Object}   props
 * @return {HTMLElement}
 */
export const ShadowContent = props => {
	const {children, className, id, ...rest} = props;

	return <div
		className={classnames("shadow-content", className)}
		lang="en"
		{...(id ? {id: id} : undefined)}
		{...rest}
	>
		{children}
	</div>;
};
